import styled from 'styled-components';

const ErrorHint = styled.div`
  font-size: var(--font-size-default);
  color: var(--color-error);
  padding-top: 2px;
`;

export default ErrorHint;
